import Vue from 'vue';
import VueRouter from 'vue-router';
import PageNotFound from '@/views/PageNotFound';
import MainComponent from '@/components/MainComponent';
import AuthComponent from '@/components/AuthComponent';
import {getFromLocalStorage} from '@/utils/local-storage.util';
import AccessDenied from '@/views/AccessDenied';
import LogoutView from '@/views/LogoutView';
import {changeUserPrivileges, USER_PRIVILEGES} from '@/store/modules/authentication';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: MainComponent,
    children: [
      {
        path: '',
        component: () => import('../views/main/HomeView.vue'),
        meta: {
          auth: true
        },
        children: [
          {
            path: 'admin',
            component: () => import('../layouts/ConfigurationLayout.vue'),
            children: [
              {
                path: 'pages',
                component: () => import('../layouts/EmptyLayout.vue'),
                children: [
                  {
                    path: 'home',
                    name: 'page-home',
                    component: () => import('../views/configurations/pages/HomeView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  },
                  {
                    path: 'about-us',
                    name: 'page-about-us',
                    component: () => import('../views/configurations/pages/AboutUsView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  },
                  {
                    path: 'why-we',
                    name: 'page-why-we',
                    component: () => import('../views/configurations/pages/WhyWeView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  },
                  {
                    path: 'skills',
                    name: 'page-skills',
                    component: () => import('../views/configurations/pages/SkillView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  },
                  {
                    path: 'contacts',
                    name: 'page-contacts',
                    component: () => import('../views/configurations/pages/ContactView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  },
                  {
                    path: 'fun-facts',
                    name: 'page-fun-facts',
                    component: () => import('../views/configurations/pages/FunFactView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  },
                  {
                    path: 'social-links',
                    name: 'page-social-links',
                    component: () => import('../views/configurations/pages/SocialLinkView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  },
                  {
                    path: 'services',
                    name: 'page-services',
                    component: () => import('../views/configurations/pages/ServiceView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  },
                  {
                    path: 'projects',
                    name: 'page-projects',
                    component: () => import('../views/configurations/pages/ProjectView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  },
                  {
                    path: 'testimonials',
                    name: 'page-testimonials',
                    component: () => import('../views/configurations/pages/TestimonialView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  },
                  {
                    path: 'staff',
                    name: 'page-staff',
                    component: () => import('../views/configurations/pages/StaffView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  },
                  {
                    path: 'faq',
                    name: 'page-faq',
                    component: () => import('../views/configurations/pages/FaqView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  },
                  {
                    path: 'privacy-policy',
                    name: 'page-privacy-policy',
                    component: () => import('../views/configurations/pages/PrivacyPolicyView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  },
                  {
                    path: 'public-offer',
                    name: 'page-public-offer',
                    component: () => import('../views/configurations/pages/PublicOfferView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  }
                ]
              },
              {
                path: 'user-management',
                component: () => import('../layouts/EmptyLayout.vue'),
                children: [
                  {
                    path: 'user-groups',
                    name: 'user-groups-configurations',
                    component: () => import('@/views/configurations/user-management/UserGroupsView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  },
                  {
                    path: 'users',
                    name: 'users-configurations',
                    component: () => import('@/views/configurations/user-management/UsersView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  }
                ]
              },
              {
                path: 'settings',
                component: () => import('../layouts/EmptyLayout.vue'),
                children: [
                  {
                    path: 'price-policy',
                    name: 'settings-price-policy',
                    component: () => import('../views/configurations/settings/PricePolicyView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  },
                  {
                    path: 'currency',
                    name: 'settings-currency',
                    component: () => import('../views/configurations/settings/CurrencyView.vue'),
                    meta: {
                      permissions: ['admin-get']
                    }
                  }
                ]
              },
            ]
          },
          {
            path: 'store',
            component: () => import('../layouts/ShopConfigurationLayout.vue'),
            children: [
              //orders, products, clients, product-reviews, requests, settings
              {
                path: 'orders',
                name: 'orders',
                component: () => import('../views/main/order/OrderView.vue'),
                meta: {
                  permissions: ['shop-get']
                }
              },
              {
                path: 'products',
                name: 'products',
                component: () => import('../views/main/product/ProductsView.vue'),
                meta: {
                  permissions: ['shop-get']
                }
              },
              {
                path: 'clients',
                name: 'clients',
                component: () => import('../views/main/ClientsView.vue'),
                meta: {
                  permissions: ['shop-get']
                }
              },
              {
                path: 'blogs',
                name: 'blogs',
                component: () => import('../views/main/blog/BlogsView.vue'),
                meta: {
                  permissions: ['shop-get']
                }
              },
              {
                path: 'product-reviews',
                name: 'productReviews',
                component: () => import('../views/main/product/ProductReviewsView.vue'),
                meta: {
                  permissions: ['shop-get']
                }
              },
              {
                path: 'requests',
                component: () => import('../layouts/EmptyLayout.vue'),
                children: [
                  {
                    path: 'tornado',
                    name: 'requests-tornado',
                    component: () => import('../views/main/requests/RequestTornadoView.vue'),
                    meta: {
                      permissions: ['shop-get']
                    }
                  },
                  {
                    path: 'store-tornado',
                    name: 'requests-store-tornado',
                    component: () => import('../views/main/requests/RequestShopView.vue'),
                    meta: {
                      permissions: ['shop-get']
                    }
                  },
                ]
              },
              {
                path: 'settings',
                component: () => import('../layouts/EmptyLayout.vue'),
                children: [
                  {
                    path: 'coupons',
                    name: 'settings-coupon',
                    component: () => import('../views/main/settings/CouponView.vue'),
                    meta: {
                      permissions: ['shop-get']
                    }
                  },
                  {
                    path: 'branches',
                    name: 'settings-branch',
                    component: () => import('../views/main/settings/BranchView.vue'),
                    meta: {
                      permissions: ['shop-get']
                    }
                  },
                  {
                    path: 'product-categories',
                    name: 'settings-product-category',
                    component: () => import('../views/main/settings/ProductCategoryView.vue'),
                    meta: {
                      permissions: ['shop-get']
                    }
                  },
                  {
                    path: 'product-subcategories',
                    name: 'settings-product-subcategory',
                    component: () => import('../views/main/settings/ProductSubcategoryView.vue'),
                    meta: {
                      permissions: ['shop-get']
                    }
                  },
                  {
                    path: 'product-brands',
                    name: 'settings-product-brand',
                    component: () => import('../views/main/settings/ProductBrandView.vue'),
                    meta: {
                      permissions: ['shop-get']
                    }
                  }
                ]
              },
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/',
    component: AuthComponent,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('../views/LoginView.vue')
      },
      {
        path: '/restore-user-password',
        name: 'restore-user-password',
        component: () => import('../views/UserRestorePasswordView.vue')
      },
      {
        path: '/confirm-restore-user-password',
        name: 'confirm-restore-user-password',
        component: () => import('../views/UserConfirmRestorePasswordView.vue')
      }
    ]
  },
  {
    path: '/logout',
    component: LogoutView
  },
  {
    path: '/access-denied',
    component: AccessDenied
  },
  {
    path: '*',
    component: PageNotFound
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// check redirect role,permission
router.beforeEach(async (to, from, next) => {
  const isLoggedIn = getFromLocalStorage('accessToken');
  
  if (to.matched.some((m) => m.meta.auth) && !isLoggedIn) {
    return next({
      path: `/login`,
      query: {
        redirectAfter: to.path
      }
    });
  }
  
  const tmpUser = getFromLocalStorage('user');
  if (isLoggedIn && tmpUser) {
    if (USER_PRIVILEGES === null) {
      const user = JSON.parse(tmpUser);
      // to clear localstorage and logout
      if (!user.userGroup) {
        localStorage.clear();
        location.reload();
      }
      changeUserPrivileges(user.userGroup.privileges);
    }
    
    const allRoutePermissions = to.matched
        .filter((m) => m.meta.permissions && m.meta.permissions.length)
        .reduce((acc, curr) => {
          acc.push(...curr.meta.permissions);
          return acc;
        }, []);
    
    if (!allRoutePermissions.every((role) => !!USER_PRIVILEGES[role])) {
      return next({
        path: '/access-denied',
        query: {
          fromPage: from.path
        }
      });
    }
  }
  
  // end check router prior with permission, role
  return next();
});

export default router;
